import React, { useState, useEffect, useCallback } from 'react';
import { api } from './api';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import AdminPage from './pages/AdminPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfilePage from './pages/ProfilePage';
import TrainingPage from './pages/TrainingPage';
import AccessPage from './pages/AccessPage';
import MonitoringPage from './pages/MonitoringPage';
import SettingsPage from './pages/SettingsPage';
import EstimatesPage from './pages/EstimatesPage';
import './App.css';

const LOGO_SVG = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 535.39 224.17" height="224" width="535"><path d="M50.36 0h467.18c11.8 0 19.67 9.65 17.49 21.45l-24.59 133.2c-2.18 11.8-13.61 21.45-25.41 21.45H17.85c-10.5 0-17.9-7.66-17.85-17.66a21.3 21.3 0 0 1 .36-3.78l24.59-133.2C27.13 9.65 38.57 0 50.36 0z" fill="#e30016"/><path d="M85.04 101.95h112.04c1.44 0 2.85-1.18 3.12-2.62l4.29-22.68c.27-1.44-.69-2.62-2.13-2.62H90.33c-1.44 0-2.85 1.18-3.12 2.62l-4.29 22.68c-.27 1.44.68 2.62 2.13 2.62zm7.22-38.17h112.04c1.44 0 2.85-1.18 3.12-2.62l4.29-22.68c.27-1.44-.69-2.62-2.13-2.62H97.55c-1.44 0-2.85 1.18-3.12 2.62l-4.29 22.68c-.27 1.44.68 2.62 2.13 2.62zm-14.45 76.33h112.04c1.44 0 2.85-1.18 3.12-2.62l4.29-22.68c.27-1.44-.68-2.62-2.13-2.62H83.1c-1.44 0-2.85 1.18-3.12 2.62l-4.29 22.68c-.27 1.44.68 2.62 2.13 2.62zM263.18 38.08c.27-1.44 1.68-2.62 3.12-2.62h22.68c1.44 0 2.4 1.18 2.12 2.62l-18.91 99.95c-.27 1.44-1.68 2.62-3.12 2.62h-22.68c-1.44 0-2.4-1.18-2.13-2.62zm38.63 0l-18.92 99.95c-.27 1.44.69 2.62 2.13 2.62h22.68c1.44 0 2.85-1.18 3.12-2.62l18.92-99.95c.27-1.44-.69-2.62-2.13-2.62h-22.68c-1.44 0-2.85 1.18-3.12 2.62zm-77.27 0l-18.92 99.95c-.27 1.44.68 2.62 2.13 2.62h22.68c1.44 0 2.85-1.18 3.12-2.62l18.92-99.95c.27-1.44-.69-2.62-2.13-2.62h-22.68c-1.44 0-2.85 1.18-3.12 2.62zm117.95 0l-.08.4-18.84 99.55-.01.07-.01.07-.01.07-.01.07v.07l-.01.07v.19l.01.06v.01l.01.06.01.06.01.06.01.06.01.06h-.01l.02.06.02.06.02.06.02.06.02.06.02.06.02.05v.01l.02.05.03.05.03.05.03.05v.01l.03.05.03.05.03.05.03.05.04.05.04.05.04.05.04.04.04.04.04.04.04.04.04.04.05.04.04.04.05.03.05.03.05.03.05.03.05.03.05.03.06.03.05.02.06.02.06.02.06.02.06.02.06.01.06.01.07.01.07.01.07.01.07 0h112.04c1.44 0 2.85-1.18 3.12-2.62l.5-2.62 3.8-20.06 6.56-34.68.02-.1c.28-1.44-.68-2.62-2.13-2.62h-59.05c-4.61 0-2.89 2.88-1.49 4.47l26.8 30.31h-59.58l9.26-48.94h86.74c1.44 0 2.85-1.18 3.12-2.62l4.29-22.68c.28-1.44-.68-2.62-2.13-2.62-37.41 0-74.63-.4-111.97-.4-1.44 0-2.85 1.18-3.12 2.62z" fill="#fff"/></svg>')}`;

const COLOR_VARS = [
  { key: '--bg', label: 'Фон основной' },
  { key: '--bg2', label: 'Фон панели' },
  { key: '--bg3', label: 'Фон элементов' },
  { key: '--text', label: 'Текст основной' },
  { key: '--text2', label: 'Текст вторичный' },
  { key: '--accent', label: 'Акцент' },
  { key: '--accent2', label: 'Акцент ховер' },
  { key: '--border', label: 'Границы' },
  { key: '--msg-user-bg', label: 'Сообщ. пользователя' },
  { key: '--msg-ai-bg', label: 'Сообщ. ИИ фон' },
];

function applyCustomColors(colors) {
  const root = document.documentElement;
  if (!colors) return;
  Object.entries(colors).forEach(([k, v]) => {
    if (v) root.style.setProperty(k, v);
  });
}

function clearCustomColors() {
  const root = document.documentElement;
  COLOR_VARS.forEach(({ key }) => root.style.removeProperty(key));
}

function AlertsBell() {
  const [alerts, setAlerts] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    api.getAlerts().then(setAlerts).catch(() => {});
    const iv = setInterval(() => { api.getAlerts().then(setAlerts).catch(() => {}); }, 60000);
    return () => clearInterval(iv);
  }, []);

  function dismissAll() {
    api.readAllAlerts().then(() => { setAlerts([]); setShow(false); }).catch(() => {});
  }

  function dismiss(id) {
    api.readAlert(id).then(() => setAlerts(prev => prev.filter(a => a.id !== id))).catch(() => {});
  }

  return (
    <div style={{ position: 'relative', marginRight: 8 }}>
      <button onClick={() => setShow(!show)} className="theme-btn" style={{ position: 'relative', fontSize: '1rem', padding: '4px 8px' }}>
        🔔
        {alerts.length > 0 && (
          <span style={{
            position: 'absolute', top: -4, right: -4, background: 'var(--danger)', color: '#fff',
            borderRadius: '50%', width: 16, height: 16, fontSize: '0.65rem', fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>{alerts.length}</span>
        )}
      </button>
      {show && (
        <div style={{
          position: 'absolute', top: '100%', right: 0, marginTop: 8, background: 'var(--bg2)',
          border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 12,
          width: 360, zIndex: 200, boxShadow: '0 4px 20px rgba(0,0,0,0.3)', maxHeight: 400, overflowY: 'auto',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h4 style={{ fontSize: '0.85rem', margin: 0 }}>Уведомления</h4>
            {alerts.length > 0 && <button onClick={dismissAll} style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '0.75rem' }}>Прочитать все</button>}
          </div>
          {alerts.length === 0 ? (
            <div style={{ color: 'var(--text2)', fontSize: '0.85rem', padding: '12px 0', textAlign: 'center' }}>Нет уведомлений</div>
          ) : alerts.map(a => (
            <div key={a.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', gap: 8, alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.1rem' }}>{a.type === 'disk_space' ? '💾' : '⚠️'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '0.85rem' }}>{a.message}</div>
                <div style={{ fontSize: '0.7rem', color: 'var(--text2)', marginTop: 2 }}>{new Date(a.created_at + 'Z').toLocaleString()}</div>
              </div>
              <button onClick={() => dismiss(a.id)} style={{ background: 'none', border: 'none', color: 'var(--text2)', cursor: 'pointer', fontSize: '0.9rem' }}>×</button>
            </div>
          ))}
          <button onClick={() => setShow(false)} style={{ marginTop: 8, width: '100%', padding: '6px', background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--text2)', cursor: 'pointer', fontSize: '0.8rem' }}>Закрыть</button>
        </div>
      )}
    </div>
  );
}

function BalanceWidget() {
  const [balance, setBalance] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    api.getBalance().then(setBalance).catch(() => {});
    const iv = setInterval(() => { api.getBalance().then(setBalance).catch(() => {}); }, 300000);
    return () => clearInterval(iv);
  }, []);

  if (!balance) return null;

  const openaiOk = balance.openai?.status === 'connected' || balance.openai?.status === 'no_key';
  const claudeOk = balance.anthropic?.status === 'connected' || balance.anthropic?.status === 'no_key';

  return (
    <div style={{ position: 'relative', marginRight: 8 }}>
      <button
        onClick={() => setShow(!show)}
        className="theme-btn"
        style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.75rem' }}
      >
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: balance.openai?.status === 'connected' ? 'var(--success)' : '#888' }} />
        API
      </button>
      {show && (
        <div style={{
          position: 'absolute', top: '100%', right: 0, marginTop: 8, background: 'var(--bg2)',
          border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 16,
          width: 320, zIndex: 200, boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        }}>
          <h4 style={{ marginBottom: 12, fontSize: '0.85rem' }}>Статус API</h4>

          <div style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <strong style={{ fontSize: '0.85rem' }}>OpenAI (ChatGPT)</strong>
              <span style={{ fontSize: '0.75rem', color: balance.openai?.status === 'connected' ? 'var(--success)' : 'var(--danger)' }}>
                {balance.openai?.status === 'connected' ? 'Подключён' : balance.openai?.status === 'no_key' ? 'Нет ключа' : 'Ошибка'}
              </span>
            </div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>
              {balance.openai?.note || 'Проверьте баланс на platform.openai.com'}
            </div>
            <a href="https://platform.openai.com/settings/organization/billing/overview" target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-block', marginTop: 6, padding: '4px 12px', background: 'var(--accent)', color: '#fff', borderRadius: 4, fontSize: '0.75rem', textDecoration: 'none', fontWeight: 600 }}>
              Пополнить
            </a>
          </div>

          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <strong style={{ fontSize: '0.85rem' }}>Anthropic (Claude)</strong>
              <span style={{ fontSize: '0.75rem', color: balance.anthropic?.status === 'connected' ? 'var(--success)' : '#888' }}>
                {balance.anthropic?.status === 'connected' ? 'Подключён' : 'Не подключён'}
              </span>
            </div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>
              {balance.anthropic?.status === 'connected' ? 'Проверьте баланс на console.anthropic.com' : 'API ключ не указан'}
            </div>
            <a href="https://console.anthropic.com/settings/billing" target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-block', marginTop: 6, padding: '4px 12px', background: 'var(--bg3)', color: 'var(--text)', borderRadius: 4, fontSize: '0.75rem', textDecoration: 'none', border: '1px solid var(--border)' }}>
              Пополнить
            </a>
          </div>

          <button onClick={() => setShow(false)} style={{ marginTop: 12, width: '100%', padding: '6px', background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--text2)', cursor: 'pointer', fontSize: '0.8rem' }}>
            Закрыть
          </button>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [page, setPageState] = useState('chat');
  const setPage = (p) => { setPageState(p); if (user?.id) localStorage.setItem(`expomaster_page_${user.id}`, p); };
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState('light');
  const [showThemeModal, setShowThemeModal] = useState(false);
  const [customColors, setCustomColors] = useState({});
  const [uiVis, setUIVis] = useState({});

  const applyTheme = useCallback((t, colors) => {
    clearCustomColors();
    document.documentElement.setAttribute('data-theme', t);
    if (t === 'custom' && colors) {
      applyCustomColors(colors);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.me().then(u => {
        setUser(u);
        api.getUIVisibility().then(setUIVis).catch(() => {});
        const savedPage = localStorage.getItem(`expomaster_page_${u.id}`);
        if (savedPage) setPageState(savedPage);
        if (u.theme_settings) {
          try {
            const ts = JSON.parse(u.theme_settings);
            setTheme(ts.theme || 'light');
            setCustomColors(ts.colors || {});
            applyTheme(ts.theme || 'light', ts.colors);
          } catch { applyTheme('light'); }
        } else {
          applyTheme('light');
        }
      }).catch(() => { localStorage.removeItem('token'); applyTheme('light'); }).finally(() => setLoading(false));
    } else {
      applyTheme('light');
      setLoading(false);
    }
  }, [applyTheme]);

  function handleLogin(token, userData) {
    localStorage.setItem('token', token);
    setUser(userData);
    api.getUIVisibility().then(setUIVis).catch(() => {});
    const savedPage = localStorage.getItem(`expomaster_page_${userData.id}`);
    if (savedPage) setPageState(savedPage);
    if (userData.theme_settings) {
      try {
        const ts = JSON.parse(userData.theme_settings);
        setTheme(ts.theme || 'light');
        setCustomColors(ts.colors || {});
        applyTheme(ts.theme || 'light', ts.colors);
      } catch {}
    } else {
      applyTheme('light');
    }
  }

  function handleLogout() {
    localStorage.removeItem('token');
    setUser(null);
    setPageState('chat');
    setTheme('light');
    applyTheme('light');
  }

  useEffect(() => {
    const onAuthExpired = () => handleLogout();
    window.addEventListener('auth:expired', onAuthExpired);
    return () => window.removeEventListener('auth:expired', onAuthExpired);
  }, []);

  function switchTheme(t) {
    setTheme(t);
    if (t !== 'custom') {
      applyTheme(t);
      api.saveTheme(JSON.stringify({ theme: t })).catch(() => {});
    } else {
      setShowThemeModal(true);
    }
  }

  function handleColorChange(key, value) {
    const next = { ...customColors, [key]: value };
    setCustomColors(next);
    document.documentElement.style.setProperty(key, value);
  }

  function saveCustomTheme() {
    applyTheme('custom', customColors);
    api.saveTheme(JSON.stringify({ theme: 'custom', colors: customColors })).catch(() => {});
    setShowThemeModal(false);
  }

  function getComputedColor(key) {
    if (customColors[key]) return customColors[key];
    return getComputedStyle(document.documentElement).getPropertyValue(key).trim();
  }

  if (loading) return <div className="loader">Загрузка...</div>;
  if (!user) return <LoginPage onLogin={handleLogin} logoSrc={LOGO_SVG} />;

  const isAdmin = user.role === 'admin';
  const perms = user.permissions || {};
  const hasPerm = (p) => isAdmin || !!perms[p];

  const pagePerms = { admin: 'manage_users', analytics: 'analytics_view', monitoring: 'monitoring_view', access: 'manage_access', estimates: 'estimates_view', training: 'training_manage' };
  const activePage = (pagePerms[page] && !hasPerm(pagePerms[page])) ? 'chat' : page;
  const uiShow = (id) => uiVis[id] !== false;

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav-brand">
          <img src={LOGO_SVG} alt="EMG" />
          <span>EXPOMASTER</span>
        </div>
        <div className="nav-links">
          {uiShow('nav_chat') && <button className={activePage === 'chat' ? 'active' : ''} onClick={() => setPage('chat')}>Чат</button>}
          {uiShow('nav_employees') && (isAdmin || hasPerm('manage_users')) && (
            <button className={activePage === 'admin' ? 'active' : ''} onClick={() => setPage('admin')}>Сотрудники</button>
          )}
          {uiShow('nav_analytics') && (isAdmin || hasPerm('analytics_view')) && (
            <button className={activePage === 'analytics' ? 'active' : ''} onClick={() => setPage('analytics')}>Аналитика</button>
          )}
          {uiShow('nav_monitoring') && (isAdmin || hasPerm('monitoring_view')) && (
            <button className={activePage === 'monitoring' ? 'active' : ''} onClick={() => setPage('monitoring')}>Мониторинг</button>
          )}
          {uiShow('nav_access') && (isAdmin || hasPerm('manage_access')) && (
            <button className={activePage === 'access' ? 'active' : ''} onClick={() => setPage('access')}>Доступы</button>
          )}
          {isAdmin && (
            <button className={activePage === 'settings' ? 'active' : ''} onClick={() => setPage('settings')}>Настройки</button>
          )}
          {uiShow('nav_estimates') && (isAdmin || hasPerm('estimates_view')) && (
            <button className={activePage === 'estimates' ? 'active' : ''} onClick={() => setPage('estimates')}>Сметы</button>
          )}
          {uiShow('nav_training') && (isAdmin || hasPerm('training_manage')) && <button className={activePage === 'training' ? 'active' : ''} onClick={() => setPage('training')}>Обучение ИИ</button>}
          {uiShow('nav_profile') && <button className={activePage === 'profile' ? 'active' : ''} onClick={() => setPage('profile')}>Профиль</button>}
        </div>
        <div className="theme-bar">
          {isAdmin && <AlertsBell />}
          {uiShow('ui_balance_widget') && isAdmin && <BalanceWidget />}
          {uiShow('ui_theme_switcher') && <>
            <button className={`theme-btn ${theme === 'light' ? 'active' : ''}`} onClick={() => switchTheme('light')}>Светлая</button>
            <button className={`theme-btn ${theme === 'dark' ? 'active' : ''}`} onClick={() => switchTheme('dark')}>Тёмная</button>
            <button className={`theme-btn ${theme === 'custom' ? 'active' : ''}`} onClick={() => switchTheme('custom')}>Настроить</button>
          </>}
        </div>
        <div className="nav-user">
          <span>{user.display_login || user.name}</span>
          <button onClick={handleLogout} className="btn-logout">Выйти</button>
        </div>
      </nav>
      <main className="main">
        <div style={{ display: activePage === 'chat' ? 'contents' : 'none' }}><ChatPage user={user} uiVis={uiVis} /></div>
        {activePage === 'admin' && (isAdmin || hasPerm('manage_users')) && <AdminPage />}
        {activePage === 'analytics' && (isAdmin || hasPerm('analytics_view')) && <AnalyticsPage user={user} />}
        {activePage === 'monitoring' && (isAdmin || hasPerm('monitoring_view')) && <MonitoringPage user={user} />}
        {activePage === 'access' && (isAdmin || hasPerm('manage_access')) && <AccessPage />}
        {activePage === 'settings' && isAdmin && <SettingsPage onVisibilityChange={setUIVis} />}
        {activePage === 'estimates' && (isAdmin || hasPerm('estimates_view')) && <EstimatesPage uiVis={uiVis} isAdmin={isAdmin} />}
        {activePage === 'training' && (isAdmin || hasPerm('training_manage')) && <TrainingPage user={user} />}
        {activePage === 'profile' && <ProfilePage user={user} />}
      </main>

      {showThemeModal && (
        <div className="modal-overlay" onClick={() => setShowThemeModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ width: 500 }}>
            <h3>Настройка цветов</h3>
            <p style={{ color: 'var(--text2)', fontSize: '0.85rem', marginBottom: 16 }}>
              Выберите свои цвета для интерфейса. Настройки сохраняются для вашего аккаунта.
            </p>
            {COLOR_VARS.map(({ key, label }) => (
              <div className="color-row" key={key}>
                <label>{label}</label>
                <input type="color" value={getComputedColor(key) || '#000000'} onChange={e => handleColorChange(key, e.target.value)} />
                <input type="text" value={customColors[key] || ''} onChange={e => handleColorChange(key, e.target.value)} placeholder="auto" />
              </div>
            ))}
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => { setShowThemeModal(false); if (theme !== 'custom') applyTheme(theme); }}>Отмена</button>
              <button className="btn-save" onClick={saveCustomTheme}>Сохранить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
